import React from 'react';

import { ArrayFieldTemplateProps } from '@rjsf/utils';

import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, IconButton, Stack } from '@mui/material';

function PromotionsArrayFieldTemplate({
  items,
  handleDelete,
  canAdd,
  onAddClick,
}: ArrayFieldTemplateProps & { handleDelete: (index: number) => void }) {
  return (
    <Box>
      {items.map((item) => {
        const itemProps = item.props as { buttonsProps?: { hasRemove?: boolean }; index?: number };
        const hasRemove = itemProps?.buttonsProps?.hasRemove;
        const index = itemProps?.index ?? 0;

        return (
          <Stack direction="row" spacing={4} key={item.key}>
            <Box flexGrow={1}>{item}</Box>

            <Stack direction="column" spacing={1}>
              {hasRemove && (
                <Box>
                  <IconButton
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDelete(index);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )}
            </Stack>
          </Stack>
        );
      })}

      {canAdd && (
        <Box mt={2}>
          <Button variant="text" onClick={onAddClick}>
            Add New Promotion
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default PromotionsArrayFieldTemplate;
